<template>
    <div id="duplicate-modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm" style="width: 400px">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">DUPLICATE TEMPLATE SETTINGS</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <form data-vv-scope="duplicate-template">
                                <div class="form-group" :class="{ 'has-error': errors.has('duplicate-template.Name') }">
                                    <label>Template Name</label>
                                    <input type="text" class="form-control" v-model="duplicateName" name="Name" v-validate="'required'">
                                    <span v-show="errors.has('duplicate-template.Name')" class="help-block">{{ errors.first('duplicate-template.Name') }}</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn green mt-ladda-btn ladda-button duplicated-btn" @click.prevent="runDuplicate"
                            data-style="expand-left">
                        <span class="ladda-label">Duplicate Template</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import Vue from "vue";

    export default {

        props: ['duplicateTemplateId'],
        data() {
            return {
                duplicateName: '',
                show: false,
            }
        },

        computed: {
            ...mapGetters({
                'errors': 'emails/getErrors',
                'newTemplate': 'emails/getLastCreatedTemplate'
            })
        },

        mounted() {
            $('#duplicate-modal').modal('show');
            $('#duplicate-modal').on('hidden.bs.modal', () => {
                this.$emit('hide');
            });
        },

        methods: {
            ...mapActions('emails', [
                'duplicateTemplate'
            ]),

            runDuplicate() {
                this.$validator.validateAll('duplicate-template').then((result) => {
                    if (result) {

                        this.button = Ladda.create(document.querySelector('.duplicated-btn'));
                        this.button.start();

                        this.duplicateTemplate({
                            template_id: this.duplicateTemplateId,
                            name: this.duplicateName
                        }).then((response) => {
                            this.button.stop();
                            $('#duplicate-modal').modal('hide');

                            if (!this.errors.duplicatingTemplate) {
                                this.$emit('duplicate-success', this.newTemplate.id);
                                this.$notify({type: 'success', text: 'Duplication success!'});
                            } else {
                                this.$notify({type: 'error', text: 'Duplication failed!'});
                            }
                        });
                    }
                });
            },
        },

        inject: {
            $validator: '$validator'
        }
    }
</script>



// WEBPACK FOOTER //
// DuplicateTemplateModal.vue?2726885f